// extracted by mini-css-extract-plugin
module.exports = {"Rank":"Rank--1dEk_","header":"header--20583","headerLeft":"headerLeft--1HzXu","headerRight":"headerRight--xzsaj","content":"content--RMeWZ"};